import FRAME from './frame.json';
import SEAT_SLING from './seat_sling.json';
import BACKREST from './backrest.json';
import SIDEGUARDS from './sideguards.json';
import FOOTREST from './footrest.json';
import CASTERS from './casters.json';
import REAR_WHEELS from './rear_wheels.json';
import WHEEL_LOCKS from './wheel_locks.json';
import ADDONS from './addons.json';

export default {
  FRAME,
  SEAT_SLING,
  BACKREST,
  SIDEGUARDS,
  FOOTREST,
  CASTERS,
  REAR_WHEELS,
  WHEEL_LOCKS,
  ADDONS
}
